import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { LoadableAfterPaint } from '@confluence/loadable';

const GuestsSettingsPageRouteComponent = LoadableAfterPaint({
	loader: async () =>
		import(
			/* webpackChunkName: "loadable-GuestsSettingsPageRouteComponent" */ './GuestsSettingsPageRouteComponent.tsx'
		),
});

export const GuestsSettingsPageRoute = () => <GuestsSettingsPageRouteComponent />;

GuestsSettingsPageRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: {
			name: 'guestsSettingsScreen',
		},
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
